import { render, staticRenderFns } from "./CalendarAndAlarms.vue?vue&type=template&id=36feaf91&"
import script from "./CalendarAndAlarms.vue?vue&type=script&lang=js&"
export * from "./CalendarAndAlarms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports